import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";
import dialog from "@utils/dialog";

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT");
  const { fullPath, name } = router.currentRoute;
  cookie.set("login_back_url", backUrl || fullPath);
  if (isWeixin()) {
    oAuth();
  } else {
    if (name !== "Login") {
		// return dialog.toast({ mes: "请前往微信登录" });
      push ? router.push({ path: "/login" }): router.replace({ path: "/login" });
    }
  }
}
